<template>
    <div class="row form_block mt_sm">
        <div class="col-12">
            <form action="" id="editPayerForm">
                <fieldset :disabled="disabled">

                <div class="info_title form_block_title">
                    <b v-if="form.id">Редактирование плательщика &laquo;{{ oldName }}&raquo;</b>
                    <b v-else>Новый плательщик</b>
                </div>
                <div class="info_body">
                    <div class="form_block_checks">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="type"
                                id="payerType1" value="1" checked
                                @change.o="resetErrors"
                                v-model="form.type">
                            <label class="form-check-label" for="payerType1">Юридическое лицо</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="type"
                                id="payerType2" value="2"
                                @change.o="resetErrors"
                                v-model="form.type">
                            <label class="form-check-label" for="payerType2">Индивидуальный предприниматель</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="type"
                                id="payerType3" value="3"
                                @change.o="resetErrors"
                                v-model="form.type">
                            <label class="form-check-label" for="payerType3">Физическое лицо</label>
                        </div>
                    </div>

                    <!-- Юр. лицо -->
                    <div v-if="form.type == 1">
                        <div class="form-group mt_sm">
                            <label for="payerINN">ИНН</label>
                            <input type="text" class="form-control" id="payerINN" name="inn" value="" minlength="10" maxlength="10"
                                :class="{ 'is-invalid': errors.inn }"
                                v-model="form.inn">
                            <div class="invalid-feedback" v-if="errors.inn">
                                {{ errors.inn }}
                            </div>
                        </div>
                        <button type="button" class="btn btn_sm btn_neutral" @click="getPayerByINN">Загрузить данные по ИНН</button>

                        <div class="form-group mt_sm">
                            <label for="payerName">Сокращенное наименование</label>
                            <input type="text" class="form-control" id="payerName" name="name" value="" maxlength="255"
                                :class="{ 'is-invalid': errors.name }" readonly
                                v-model="form.name">
                            <div class="invalid-feedback" v-if="errors.name">
                                {{ errors.name }}
                            </div>
                            <small id="" class="text-muted">Например, ООО “Шелковый Путь”</small>
                        </div>
                    </div>

                    <!-- ИП -->
                    <div v-if="form.type == 2">
                        <div class="form-group mt_sm">
                            <label for="payerINN">ИНН</label>
                            <input type="text" class="form-control" id="payerINN" name="inn" value="" minlength="12" maxlength="12"
                                :class="{ 'is-invalid': errors.inn }"
                                v-model="form.inn">
                            <div class="invalid-feedback" v-if="errors.inn">
                                {{ errors.inn }}
                            </div>
                        </div>
                        <button type="button" class="btn btn_sm btn_neutral" @click="getPayerByINN">Загрузить данные по ИНН</button>

                        <div class="form-group mt_sm">
                            <label for="payerName">Наименование индивидуального предпринимателя</label>
                            <input type="text" class="form-control" id="payerName" name="name" value="" maxlength="32"
                                :class="{ 'is-invalid': errors.name }" readonly
                                v-model="form.name">
                            <div class="invalid-feedback" v-if="errors.name">
                                {{ errors.name }}
                            </div>
                            <small id="" class="text-muted">Например, ИП Иванов Иван Иванович</small>
                        </div>
                    </div>

                    <!-- Физ. лицо -->
                    <div v-if="form.type == 3">
                        <div class="form-group mt_sm">
                            <label for="payerName">Ф.И.О.</label>
                            <input type="text" class="form-control" id="payerName" name="name" value="" maxlength="32"
                                :class="{ 'is-invalid': errors.name }"
                                v-model="form.name">
                            <div class="invalid-feedback" v-if="errors.name">
                                {{ errors.name }}
                            </div>
                            <small id="" class="text-muted">Например, Иванов Иван Иванович</small>
                        </div>
                    </div>

                    <div class="form-group mt_sm">
                        <label for="payerEmail">Электронная почта</label>
                        <input type="text" class="form-control" id="payerEmail" name="email" value="" maxlength="48"
                               :class="{ 'is-invalid': errors.email }"
                               v-model="form.email">
                        <div class="invalid-feedback" v-if="errors.email">
                            {{ errors.email }}
                        </div>
                        <small id="" class="text-muted">Для документов, например,
                            director@valentina.ru</small>
                    </div>

                    <div class="form-group mt_sm">
                        <label for="payerPhone">Контактный телефон</label>
                        <masked-input type="tel" class="form-control" id="payerPhone" name="phone" value=""
                            mask="\+\7 111 111 1111"
                            placeholder="+7 555 555 5555"
                            :class="{ 'is-invalid': errors.phone }"
                            v-model="form.phone" />
                        <div class="invalid-feedback" v-if="errors.phone">
                            {{ errors.phone }}
                        </div>
                        <small id="" class="text-muted">По финансовым вопросам, например, гл.
                            бухгалтера</small>
                    </div>

                    <!-- <div v-if="(form.type == 2 || form.type == 1) && form.id" class="form-group mt_sm">
                        <label for="payerFiles">Реквизиты</label>

                        <ul v-if="form.files.length" v-for="file in form.files">
                            <li><a :href="'/storage/' + file.path" target="_blank">{{ file.original_filename}}</a></li>
                        </ul>

                        <input type="file" class="form-control" id="payerFiles" name="files" multiple ref="files"
                               :class="{ 'is-invalid': errors.files }"
                               v-on:change="fileChange">
                        <div class="invalid-feedback" v-if="errors.files">
                            {{ errors.files }}
                        </div>
                        <small id="" class="text-muted"></small>

                        <button type="button" class="btn btn_lg btn_common mt_xxs" @click.prevent="uploadFiles">Загрузить файлы</button>
                    </div> -->

                    <button type="button" class="btn btn_lg btn_common mt_xxs" @click.prevent="checkForm" :disabled="disabled">{{ disabled ? 'Сохраняем...' : 'Сохранить' }}</button>
                    <button v-if="editMode" type="button" class="btn btn_lg btn_neutral  mt_xxs" @click.prevent="resetForm">Отмена</button>

                </div>

            </fieldset>
            </form>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {en, ru} from 'vuejs-datepicker/dist/locale';
import MaskedInput from 'vue-masked-input'

export default {
    components: {
        Datepicker,
        MaskedInput
    },
    data: function () {
        return {
            dateFormat: 'yyyy-MM-dd',
            disabledDates: {
                from: new Date()
            },
            en: en,
            ru: ru,
            files: null
        }
    },
    methods: {
        resetHighlited: function() {
            Array.from(document.querySelectorAll('.highlighted')).forEach((el) => el.classList.remove('highlighted'));
        },

        checkForm: function (e) {
            let errors = {};
            this.$store.commit("payer/resetErrors");


            let reEmail = /\S+@\S+\.\S+/;
            let rePhone = /^\+[0-9][0-9]{3}[\ ]?[0-9]{3}[\ ]?[0-9]{4}$/im;


            let fields = [];

            // Юр. лицо
            if (this.form.type == 1) {
                fields = ['name', 'inn', 'email', 'phone'];

                let reInn = /^[0-9]{10}$/;

                if (!reInn.test(this.form.inn)) {
                    errors.inn = 'Необходимо 10 символов';
                }
            }

            // ИП
            if (this.form.type == 2) {
                fields = ['name', 'inn', 'email', 'phone'];

                let reInn = /^[0-9]{12}$/;

                if (!reInn.test(this.form.inn)) {
                    errors.inn = 'Необходимо 12 символов';
                }
            }

            // Физ. лицо
            if (this.form.type == 3) {
                fields = ['name', 'email', 'phone'];
            }


            if (!reEmail.test(this.form.email)) {
                errors.email = 'Неверный формат';
            }

            if (!rePhone.test(this.form.phone.replace(' ', ''))) {
                errors.phone = 'Неверный формат';
            }


            for (let i = 0; i < fields.length; i++) {
                if (this.form[fields[i]] == '' || this.form[fields[i]] == null) {
                    // this.errors[fields[i]] = 1;
                    errors[fields[i]] = 'Заполните поле';
                }
            }

            this.$store.commit("payer/setErrors", errors);

            if (Object.keys(errors).length == 0) {
                if (this.editMode) {
                    this.updatePayer();
                } else {
                    this.addPayer();
                }
            }
        },

        resetErrors: function (e) {
            this.$store.commit("payer/resetErrors");
        },

        resetForm: function (e) {
            this.resetHighlited();
            this.resetErrors();
            this.$store.commit("payer/resetForm");
        },

        addPayer() {
            this.resetHighlited();
            this.$store.dispatch("payer/addPayer");
        },

        updatePayer() {
            this.resetHighlited();
            this.$store.dispatch("payer/updatePayer");
        },

        getPayerByINN() {
            this.resetHighlited();
            let inn = this.form.inn;

            this.$store.dispatch("payer/getPayerByINN", inn);
        },

        fileChange() {
            this.files = this.$refs.files.files;
        },

        uploadFiles() {
            let formData = new FormData();

            formData.append('id', this.form.id);

            for (let i = 0; i < this.files.length; i++ ){
                let file = this.files[i];
                formData.append('files[' + i + ']', file);
            }

            this.$store.dispatch("payer/uploadFiles", formData);
        },
    },
    computed: {
        ok() {
            return this.$store.state.payer.ok;
        },
        form() {
            return this.$store.state.payer.payer;
        },
        oldName() {
            return this.$store.state.payer.oldName;
        },
        editMode() {
            return this.$store.state.payer.editMode;
        },
        errors() {
            return this.$store.state.payer.errors;
        },
        payer() {
            return this.$store.state.payer.form;
        },
        disabled() {
            return this.$store.state.payer.saving;
        },
        days() {
            let result = [];

            for (let i = 1; i <= 31; i++) {
                result.push({
                    value: i < 10 ? '0' + i : '' + i,
                    title: i,
                });
            }

            return result;
        },
        months() {
            let result = [
                {
                    value: '01',
                    title: 'Январь'
                },
                {
                    value: '02',
                    title: 'Февраль'
                },
                {
                    value: '03',
                    title: 'Март'
                },
                {
                    value: '04',
                    title: 'Апрель'
                },
                {
                    value: '05',
                    title: 'Май'
                },
                {
                    value: '06',
                    title: 'Июнь'
                },
                {
                    value: '07',
                    title: 'Июль'
                },
                {
                    value: '08',
                    title: 'Август'
                },
                {
                    value: '09',
                    title: 'Сентябрь'
                },
                {
                    value: '10',
                    title: 'Октябрь'
                },
                {
                    value: '11',
                    title: 'Ноябрь'
                },
                {
                    value: '12',
                    title: 'Декабрь'
                },
            ];

            return result;
        },
    }
};
</script>
